import SEOHEAD from "@components/SEOHEAD";
import React, { FC } from "react";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

const pagination = {
  clickable: true,
  renderBullet: function (index: number, className: string) {
    return '<span  class="' + " " + className + '">' + "</span>";
  },
};

type Props = {
  students: [
    {
      description: string;
      fullName: string;
      id: number;
      image: string;
    }
  ];
};

const AboutMe: FC<Props> = ({ students }) => {
  return (
    <>
      <div className="flex w-full flex-col items-center justify-center px-[10%]">
        <div className="text-base font-bold text-[#3D3C3C] md:text-2xl">
          از زبان دانش‌پذیران ما
        </div>
        <p className="mdLtext-xl my-7 text-sm text-[#999696]">
          {" "}
          آنچه دانش‌پذیران درباره ما می‌گویند{" "}
        </p>
        <div className="custom-bullet-about relative h-auto w-full">
          <Swiper
            pagination={pagination}
            modules={[Pagination]}
            breakpoints={{
              375: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              767: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
            className="flex flex-col-reverse justify-center pb-20"
          >
            {students?.map(({ description, fullName, id, image }) => (
              <SwiperSlide
                className="flex justify-center"
                key={JSON.stringify(id)}
              >
                <div className="flex h-auto w-full flex-col items-center px-4 text-center text-black-450">
                  <img
                    loading="lazy"
                    src={image}
                    className="mb-10 h-auto w-8/12 rounded-full"
                    alt={fullName}
                  />
                  <h5 className="mb-4 text-sm font-semibold md:text-lg">
                    {fullName}
                  </h5>
                  <p className="text-justify text-xs md:text-base">
                    {description}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default AboutMe;
